// extracted by mini-css-extract-plugin
export default {"searchComponent":"Search_searchComponent__yaKnt","searchContainer":"Search_searchContainer__jjiYE","search":"Search_search__c7lwS","closed":"Search_closed__xHO1Y"};